import sienna from './sienna'
import { getScriptDataAttribute } from './utils/getScriptDataAttribute'
import observeHTMLLang from './utils/observeHTMLLang'
import { loadLanguages } from '@/i18n/Languages'

async function initialize() {
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    document.removeEventListener('readystatechange', initialize)

    const position = getScriptDataAttribute('position')
    const offset = getScriptDataAttribute('offset')?.split(',').map(Number)
    const sizeRaw = getScriptDataAttribute('size')
    const size = sizeRaw ? Number(sizeRaw) : undefined

    const options: Record<string, unknown> = {
      lang: 'id',
    }
    if (position) options.position = position
    if (offset) options.offset = offset
    if (size !== undefined && !Number.isNaN(size)) options.size = size

    await loadLanguages()
    window.SiennaPlugin = sienna({
      options,
    })

    if (!getScriptDataAttribute('disableObserveLang')) {
      observeHTMLLang()
    }
  }
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  // Initialize if the script is appended to the DOM when document.readyState is completed
  initialize()
} else {
  // Use readystatechange for async support
  document.addEventListener('readystatechange', initialize)
}
